var _style, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FF9800;}\n\t.st1{fill:#EF5350;}\n\t.st2{fill:#4CAF50;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M71.8,46.8c-0.7,0-1.2-0.3-1.6-0.9c-0.4-0.6-0.4-1.2,0-1.8l23.2-40c0.4-0.6,0.9-0.9,1.6-0.9 c0.7,0,1.2,0.3,1.6,0.9l23.2,40c0.4,0.6,0.4,1.2,0,1.8c-0.4,0.6-0.9,0.9-1.6,0.9H71.8z M95.2,19.8c-0.5,0-0.9,0.2-1.3,0.5 c-0.3,0.3-0.5,0.8-0.5,1.3v9.8c0,0.5,0.2,0.9,0.5,1.3c0.3,0.3,0.8,0.5,1.3,0.5c0.5,0,0.9-0.2,1.3-0.5c0.3-0.3,0.5-0.8,0.5-1.3v-9.8 c0-0.5-0.2-0.9-0.5-1.3C96.2,20,95.8,19.8,95.2,19.8z M95.2,39.8c0.5,0,0.9-0.2,1.3-0.5C96.9,39,97,38.5,97,38s-0.2-0.9-0.5-1.3 c-0.3-0.3-0.8-0.5-1.3-0.5s-0.9,0.2-1.3,0.5c-0.3,0.3-0.5,0.8-0.5,1.3s0.2,0.9,0.5,1.3C94.3,39.6,94.7,39.8,95.2,39.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M141.8,46.8c-0.7,0-1.2-0.3-1.6-0.9c-0.4-0.6-0.4-1.2,0-1.8l23.2-40c0.4-0.6,0.9-0.9,1.6-0.9s1.2,0.3,1.6,0.9 l23.2,40c0.4,0.6,0.4,1.2,0,1.8c-0.4,0.6-0.9,0.9-1.6,0.9H141.8z M165.2,19.8c-0.5,0-0.9,0.2-1.3,0.5c-0.3,0.3-0.5,0.8-0.5,1.3v9.8 c0,0.5,0.2,0.9,0.5,1.3c0.3,0.3,0.8,0.5,1.3,0.5c0.5,0,0.9-0.2,1.3-0.5c0.3-0.3,0.5-0.8,0.5-1.3v-9.8c0-0.5-0.2-0.9-0.5-1.3 C166.2,20,165.8,19.8,165.2,19.8z M165.2,39.8c0.5,0,0.9-0.2,1.3-0.5c0.3-0.3,0.5-0.8,0.5-1.3s-0.2-0.9-0.5-1.3 c-0.3-0.3-0.8-0.5-1.3-0.5c-0.5,0-0.9,0.2-1.3,0.5c-0.3,0.3-0.5,0.8-0.5,1.3s0.2,0.9,0.5,1.3C164.3,39.6,164.7,39.8,165.2,39.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M25,0C11.2,0,0,11.2,0,25s11.2,25,25,25s25-11.2,25-25S38.8,0,25,0z M40.2,16.5L21,35.7 c-0.2,0.2-0.3,0.3-0.5,0.3s-0.4,0.1-0.5,0.1c-0.2,0-0.4,0-0.6-0.1c-0.2-0.1-0.3-0.2-0.5-0.3l-9-9.1c-0.3-0.3-0.5-0.7-0.5-1.1 s0.2-0.8,0.5-1.1c0.3-0.3,0.7-0.5,1-0.5c0.4,0,0.8,0.1,1.1,0.5l8,8L38,14.3c0.3-0.3,0.7-0.5,1.1-0.5c0.4,0,0.8,0.2,1.1,0.5 s0.5,0.7,0.5,1.1C40.7,15.8,40.5,16.1,40.2,16.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.b7b0eb26c7c26b67889345eadf1cff88.svg";
export { ForwardRef as ReactComponent };